import { render, staticRenderFns } from "./SchoolServices.vue?vue&type=template&id=04143556"
import script from "./SchoolServices.vue?vue&type=script&lang=js"
export * from "./SchoolServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports